import { useRequiredContext } from '#hooks/use-required-context/index.ts';
import { ExperienceContext } from '#providers/experiences/Experience.context.ts';
import type { TExperienceContextValue } from '#providers/experiences/Experience.types.ts';

export const useExperience = (): TExperienceContextValue =>
  useRequiredContext(
    ExperienceContext,
    'useExperience is only available inside an ExperienceProvider',
  );
